// RolServicio.js
import React, { useState, useCallback, useEffect } from "react";
import { Link, useLocation, useNavigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "bootstrap-icons/font/bootstrap-icons.css";

const RolServicio = ({ isOpen, toggleSidebar, closeSidebar }) => {
  const [openMenus, setOpenMenus] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  // Función para alternar un submenú
  const toggleMenu = useCallback(
    (menu) => {
      if (!isOpen) {
        toggleSidebar();
        setOpenMenus((prev) => ({ ...prev, [menu]: true }));
      } else {
        setOpenMenus((prev) => ({ ...prev, [menu]: !prev[menu] }));
      }
    },
    [isOpen, toggleSidebar]
  );

  useEffect(() => {
    setOpenMenus({});
  }, [location.pathname]);

  // Cierra todos los submenús y el sidebar
  const resetMenus = useCallback(() => {
    setOpenMenus({});
    closeSidebar();
  }, [closeSidebar]);

  const isMenuOpen = (menu) => openMenus[menu] || false;

  const handleLogout = async () => {
    await logout();
    localStorage.removeItem("userRole");
    navigate("/login");
  };

  // Maneja el clic en un enlace: si cambia la ruta, cierra el sidebar
  const handleLinkClick = (path) => {
    if (location.pathname !== path) {
      closeSidebar();
    }
  };

  return (
    <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
      <div className="sidebar-header">
        <div className="logo-container-sidebar">
          <Link to="/" onClick={() => handleLinkClick("/")}>
            <img
              className={`logo ${isOpen ? "open" : "closed"}`}
              src="/img/logo-iciamex.png"
              alt="ICIAMEX logo"
            />
          </Link>
        </div>
        <Link to="/" onClick={() => handleLinkClick("/")}>
          <img className="menu-icon" src="/img/ic.svg" alt="Menu Icon" />
        </Link>
        {isOpen ? (
          <div className="menu-toggle-btn" onClick={resetMenus}>
            <i className="bi bi-chevron-left"></i>
          </div>
        ) : (
          <div className="sidebar-open-btn" onClick={toggleSidebar}>
            <i className="bi bi-chevron-right"></i>
          </div>
        )}
      </div>

      <div className="sidebar-content">
        <nav id="primary-menu" className="navbar">
          <ul className="nav navbar-nav">
            {isOpen && <span className="main-text">Principal</span>}
            {/* Página de Inicio */}
            <li
              className={`sidebar-item ${
                location.pathname === "/" ? "border-bottom-active" : ""
              }`}
              data-tooltip="Inicio"
            >
              <Link
                className={location.pathname === "/" ? "active" : ""}
                to="/"
                onClick={() => handleLinkClick("/")}
              >
                <span className="icon">
                  <i className="bi bi-house"></i>
                </span>
                <span className="text">Inicio</span>
              </Link>
            </li>
            {/* Página de Tareas */}
            <li
              className={`sidebar-item ${
                location.pathname === "/tareas" ? "border-bottom-active" : ""
              }`}
              data-tooltip="Tareas"
            >
              <Link
                className={location.pathname === "/tareas" ? "active" : ""}
                to="/tareas"
                onClick={() => handleLinkClick("/tareas")}
              >
                <span className="icon">
                  <i className="bi bi-check2-square"></i>
                </span>
                <span className="text">Tareas</span>
              </Link>
            </li>
            {/* Página de Calendario */}
            <li
              className={`sidebar-item ${
                location.pathname === "/calendario" ? "border-bottom-active" : ""
              }`}
              data-tooltip="Calendario"
            >
              <Link
                className={location.pathname === "/calendario" ? "active" : ""}
                to="/calendario"
                onClick={() => handleLinkClick("/calendario")}
              >
                <span className="icon">
                  <i className="bi bi-calendar2-day"></i>
                </span>
                <span className="text">Calendario</span>
              </Link>
            </li>

            <br />

            {isOpen && <span className="main-text">Utilidades</span>}
            {/* Menú de Inventario */}
            <li
              data-tooltip="Inventario"
              className={isMenuOpen("Inventario") ? "open" : ""}
            >
              <Link
                className={`sidebar-item ${
                  isMenuOpen("Inventario") ? "border-bottom-active" : ""
                }`}
                onClick={() => toggleMenu("Inventario")}
                data-tooltip="Inventario"
              >
                <span className="icon">
                  <i className="bi bi-box"></i>
                </span>
                <span className="text">Inventario</span>
                <div className="dropdown-arrow-container">
                  <span
                    className={`dropdown-arrow ${
                      isOpen && isMenuOpen("Inventario") ? "active" : ""
                    }`}
                  >
                    {isOpen ? (
                      isMenuOpen("Inventario") ? (
                        <i className="bi bi-chevron-up"></i>
                      ) : (
                        <i className="bi bi-chevron-right"></i>
                      )
                    ) : (
                      ""
                    )}
                  </span>
                </div>
              </Link>
              {isMenuOpen("Inventario") && (
                <ul
                  className={`sub-menu ${
                    isMenuOpen("Inventario") ? "open" : "closed"
                  }`}
                >
                  <li>
                    <Link
                      className="text"
                      to="/articulos-venta"
                      onClick={() => handleLinkClick("/articulos-venta")}
                    >
                      <span>Productos de Venta</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="text"
                      to="/articulos-compra"
                      onClick={() => handleLinkClick("/articulos-compra")}
                    >
                      <span>Productos de Compra</span>
                    </Link>
                  </li>
                  <li>
                    <Link className="text">
                      <span>Ajustes de Inventario</span>
                    </Link>
                  </li>
                  <li>
                    <Link className="text">
                      <span>Gestión de Productos</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="text"
                      to="/categorias"
                      onClick={() => handleLinkClick("/categorias")}
                    >
                      <span>Categorías</span>
                    </Link>
                  </li>
                  <li>
                    <Link className="text">
                      <span>Almacenes</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="text"
                      to="/grupos"
                      onClick={() => handleLinkClick("/grupos")}
                    >
                      <span>Grupos</span>
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* Menú de Reportes */}
            <li
              data-tooltip="Reportes"
              className={isMenuOpen("Reportes") ? "open" : ""}
            >
              <Link
                className={`sidebar-item ${
                  isMenuOpen("Reportes") ? "border-bottom-active" : ""
                }`}
                onClick={() => toggleMenu("Reportes")}
                data-tooltip="Reportes"
              >
                <span className="icon">
                  <i className="bi bi-file-earmark-bar-graph"></i>
                </span>
                <span className="text">Reportes</span>
                <div className="dropdown-arrow-container">
                  <span
                    className={`dropdown-arrow ${
                      isOpen && isMenuOpen("Reportes") ? "active" : ""
                    }`}
                  >
                    {isOpen ? (
                      isMenuOpen("Reportes") ? (
                        <i className="bi bi-chevron-up"></i>
                      ) : (
                        <i className="bi bi-chevron-right"></i>
                      )
                    ) : (
                      ""
                    )}
                  </span>
                </div>
              </Link>
              {isMenuOpen("Reportes") && (
                <ul
                  className={`sub-menu ${
                    isMenuOpen("Reportes") ? "open" : "closed"
                  }`}
                >
                  <li>
                    <Link
                      className="text"
                      to="/generador"
                      onClick={() => handleLinkClick("/generador")}
                    >
                      <span>Generador de Obra</span>
                    </Link>
                  </li>
                  <li>
                    <Link className="text">
                      <span>Opción 2</span>
                    </Link>
                  </li>
                </ul>
              )}
            </li>
          </ul>
        </nav>

        {isOpen && (
                <div
                    style={{
                    display: "flex",
                    flexDirection: "column", // Se acomodan los elementos en columna
                    alignItems: "center",    // Centra horizontalmente el contenido
                    width: "100%",
                    height: "100%",          // Ocupa toda la altura del sidebar
                    }}
                >
                    {/* Este div "invisible" empuja el botón hacia abajo */}
                    <div style={{ flexGrow: 1 }} />

                    <button
                    onClick={handleLogout}
                    style={{
                        padding: isOpen ? "15px 20px" : "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#4C5165",
                        color: "#e0e0e0",
                        borderRadius: "8px",
                        fontSize: isOpen ? "14px" : "12px",
                        width: isOpen ? "80%" : "40px",
                        height: isOpen ? "auto" : "40px",
                        marginBottom: "20px", // Espacio al final
                        cursor: "pointer",
                        border: "none",
                        transition: "all 0.3s ease-in-out",
                    }}
                    onMouseEnter={(e) => (e.target.style.backgroundColor = "#626879")}
                    onMouseLeave={(e) => (e.target.style.backgroundColor = "#4C5165")}
                    >
                    <i
                        style={{
                        marginRight: isOpen ? "10px" : "0",
                        fontSize: "16px",
                        transition: "margin 0.3s ease-in-out",
                        }}
                        className="bi bi-box-arrow-in-right"
                    ></i>
                    {isOpen && <span>Cerrar Sesión</span>}
                    </button>
                </div>
                )}
        <Outlet />
      </div>
    </div>
  );
};

export default RolServicio;
